import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { InstructionRoutesModule } from './instruction.routes';
import { InstructionComponent } from './components/instruction.component';

@NgModule({
  imports: [SharedModule, CommonModule, InstructionRoutesModule],
  declarations: [InstructionComponent],
  providers: [],
})
export class InstructionModule {}
